module.exports = __webpack_public_path__ + "img/team-9.030e6818.jpeg";